// E³ 組織結果（E3OrgResultPage）の「系列会社」選択まわりの純関数
// ------------------------------------------------------------------
// 系列会社ありグループ（GET /api/results/30010/org/options の ③ 応答が affiliate:true）のときだけ、
// 所属の前に「系列会社」を選ぶ。系列会社なしグループ（affiliate が true 以外）では、
// 画面も要求本文も従来と完全に同じにする（company キーを付けない）。

/**
 * ③ 応答から系列会社の選択情報を取り出す。系列会社なしグループは null。
 * @param {Object|null} data GET /org/options?groupCode&seasonId の応答
 * @returns {{ companies: string[], allowAllCompanies: boolean }|null}
 */
export const companyMetaOf = (data) => {
  if (!data || data.affiliate !== true) return null;
  return {
    companies: Array.isArray(data.companies) ? data.companies.filter((c) => typeof c === 'string' && c) : [],
    allowAllCompanies: data.allowAllCompanies === true,
  };
};

/**
 * 結果 API（/org・/org/compare・/org/trend・/org/comments）の本文に足す系列会社の条件。
 * 系列会社なしグループは空オブジェクト（キー自体を付けない）。'' は「全社（グループ全体）」。
 * @param {boolean} affiliate 系列会社ありグループか
 * @param {string} company 選択中の系列会社名（'' = 全社）
 */
export const companyBody = (affiliate, company) => (affiliate ? { company: company || '' } : {});

/**
 * 所属①の「〇〇全体」と、比較・推移の「全体」ラベルに使う名前。
 * 系列会社を選んでいるときはその系列会社名、それ以外（全社・系列会社なし）はグループ名。
 */
export const rootAllName = (affiliate, company, groupName) =>
  affiliate && company ? company : groupName || 'グループ';
